import { persist } from 'zustand/middleware';
import { createStore } from 'zustand/vanilla';
const PROMO_STORE_VERSION = 1;
export const PromoStore = createStore()(persist((set) => ({
    hasSubmittedPromo: false,
    hasSubmittedOrder: false,
    submitPromo: () => set({ hasSubmittedPromo: true }),
    submitOrder: () => set({ hasSubmittedOrder: true }),
}), { name: 'first_order_promo', version: PROMO_STORE_VERSION }));
